<template>
  <div>
    <v-toolbar flat dense class="mb-4">
      <v-toolbar-title>{{ $t("heading.settings") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
    </v-toolbar>
    <!-- table -->
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      pathName="settings"
      resName="settings"
      class="table-row"
    >
      <template slot-scope="{ item }">
        <td class="text-sm-center">
          {{ item.key }}
        </td>
        <td class="text-sm-center">
          <template v-if="item.type !== 'boolean'">
            <div v-if="item.value" v-html="item.value"></div>
            <div v-else>---</div>
          </template>
          <template v-else>
            <v-switch
              :loading="loading"
              @change="handleChange($event, item)"
              class="toggle-service text-center"
              inset
              :false-value="0"
              :true-value="1"
              v-model="item.value"
            ></v-switch>
          </template>
        </td>

        <td class="text-sm-center">
          <v-btn
            icon
            color="info"
            :to="`/settings/edit/${item.id}`"
            v-if="item.type !== 'boolean'"
          >
            <v-icon :title="$t('icon.edit')" small>mdi-pencil</v-icon>
          </v-btn>
        </td>
      </template>
    </wrapping-table>
    <!-- table -->
  </div>
</template>

<script>
import { StoreData } from "@/helpers/apiMethods";
export default {
  name: "Settings",

  data() {
    return {
      components: "",
      headers: ["name", "value", "actions"],
      loading: false
    };
  },
  methods: {
    handleChange(value, item) {
      this.loading = true;
      const data = {
        _method: "put",
        value,
        locale: this.locale
      };
      StoreData({ reqName: `settings/${item.id}`, data }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>
